import { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    const formData = new URLSearchParams();
    formData.append("email", email);
    try {
      await fetch("https://readdy.ai/api/form/d7o72i4jr1hvt8ntaukg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
    } catch (_) {
      // silent
    }
    setSubscribed(true);
    setEmail("");
  };

  return (
    <footer id="contact" className="bg-stone-900 pt-16 pb-8 px-4 md:px-8 lg:px-12 text-stone-400">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="/" className="flex items-center gap-2.5 text-white hover:text-primary transition-colors duration-300 mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/4e9a12fb-cddb-4082-86d9-a8d48c5e1af1/4c1dbfd3-51c3-4b4d-bce2-d21c130722c0_LOGO---BHODEV.jpeg?v=bec7ea05bbbc33a50ca492c9bcdd08aa"
                alt="BHODEV Logo"
                title="BHODEV Cameroon Official Logo"
                className="w-10 h-10 rounded-full object-cover ring-2 ring-white/10"
              />
              <div>
                <p className="text-xs font-semibold leading-tight tracking-wide">Bogi Health Organization for Development</p>
                <p className="text-xs text-primary font-bold tracking-wider">(BHODEV)</p>
              </div>
            </a>
            <p className="text-sm leading-relaxed mb-6 text-stone-400">
              Bogi Health Organization for Development (BHODEV) is an NGO working to promote health, peace, social justice &amp; sustainable development in Cameroon.
            </p>
            <div className="flex items-center gap-2.5">
              {[
                { href: "https://web.facebook.com/profile.php?id=100094000555791", icon: "ri-facebook-fill", label: "Facebook" },
                { href: "https://www.linkedin.com/in/bogi-health-organization-for-development-bhodev-805471276/", icon: "ri-linkedin-fill", label: "LinkedIn" },
                { href: "https://twitter.com/bhodevCameroon", icon: "ri-twitter-x-fill", label: "Twitter" },
                { href: "https://www.instagram.com/bhodevcameroon_ngo/", icon: "ri-instagram-line", label: "Instagram" },
                { href: "https://www.youtube.com/@bhodevcameroon", icon: "ri-youtube-fill", label: "YouTube" },
              ].map((social) => (
                <a
                  key={social.href}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center bg-stone-800 rounded-lg hover:bg-primary hover:text-white transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Address */}
          <div>
            <h4 className="text-white text-sm font-bold mb-5 tracking-wide uppercase">Contact</h4>
            <div className="flex flex-col gap-4 text-sm">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-primary"></i>
                </div>
                <span className="leading-relaxed">Clerks quarters opposite express exchange Buea, SW, Cameroon</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-primary"></i>
                </div>
                <span>+237 670396340</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-primary"></i>
                </div>
                <a href="mailto:info@bhodevcameroon.org" className="hover:text-primary transition-colors duration-300">
                  info@bhodevcameroon.org
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-sm font-bold mb-5 tracking-wide uppercase">Quick Links</h4>
            <ul className="flex flex-col gap-3 text-sm">
              {[
                { label: "About Us", href: "#about" },
                { label: "Contact Us", href: "#contact" },
                { label: "Our Projects", href: "#projects" },
                { label: "Donate", href: "/donate" },
                { label: "Get Involved", href: "/get-involved" },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="flex items-center gap-2 hover:text-white transition-colors duration-300 cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-primary"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white text-sm font-bold mb-5 tracking-wide uppercase">Newsletter</h4>
            <p className="text-sm mb-4 leading-relaxed">Subscribe and be the first to receive the Voice of Change</p>
            {subscribed ? (
              <div className="bg-secondary/20 text-primary text-sm px-4 py-3 rounded-xl font-semibold flex items-center gap-2">
                <i className="ri-check-line"></i>
                Thanks for subscribing!
              </div>
            ) : (
              <form
                data-readdy-form
                id="newsletter-form"
                onSubmit={handleSubscribe}
                className="flex flex-col gap-3"
              >
                <div className="relative">
                  <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-stone-500"></i>
                  </div>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email address"
                    required
                    className="w-full bg-stone-800 border border-stone-700 rounded-xl pl-10 pr-4 py-3 text-sm focus:outline-none focus:border-primary text-white placeholder-stone-500 transition-colors duration-300"
                  />
                </div>
                <button
                  type="submit"
                  className="bg-primary text-white px-4 py-3 rounded-xl text-sm font-semibold hover:bg-primary-dark transition-colors duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary/20"
                >
                  Subscribe
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-stone-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
          <p className="text-stone-500">
            &copy; 2019-{new Date().getFullYear()} <span className="text-stone-300 font-semibold">Bogi Health Organization for Development</span>. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4 text-stone-500">
            <a href="#" className="hover:text-white transition-colors duration-300 text-xs">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors duration-300 text-xs">Terms of Service</a>
            <a href="https://www.bradnova.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300 text-xs">Powered by Bradnova</a>
          </div>
        </div>
      </div>
    </footer>
  );
}